import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../organisms/header/header.component';
import { CommonModule } from '@angular/common';
import { MobileSidebarComponent } from '../../organisms/mobile-sidebar/mobile-sidebar.component';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, HeaderComponent, CommonModule, MobileSidebarComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {

}
